export type IShowLockScreen = (message?: string) => void;

export function showLockScreen(message?: string) {
  if (message) {
    window.DexeroCoreApp.blockUI(message, $('body'));
  } else {
    window.DexeroCoreApp.blockUI(undefined, $('body'), false, true);
  }
}
